import React from 'react';
import { SHeader1, SText, SSection } from '../../styles';
import nl2br from 'react-nl2br';

export const LaypersonsSummary = ({ title, state }) => {
  return (
    <SSection>
      <SHeader1>{title}</SHeader1>
      <SText>{nl2br(state.summary)}</SText>
    </SSection>
  );
};
